import { SimpleGrid, Stack } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { FaRegClock, FaUsers } from "react-icons/fa6";
import { TbBrowser, TbLockQuestion } from "react-icons/tb";

import { SectionTitle } from "@/components/general/section-title/section-title";

import { Card } from "../../../general/card/card";
import { Section } from "../../../general/section/section";
import styles from "./feature-section.module.css";

interface FeatureCardProps {
    icon: React.ReactNode;
    title: string;
    description: string;
    highlights?: string[];
    delay?: number;
}

export const FeatureSection = () => {
    const { t } = useTranslation();
    const features: FeatureCardProps[] = [
        {
            icon: <TbBrowser size={28} />,
            title: t("home.features.playInBrowser.title"),
            description: t("home.features.playInBrowser.description"),
            highlights: t("home.features.playInBrowser.highlights", { returnObjects: true }) as string[],
        },
        {
            icon: <FaRegClock size={28} />,
            title: t("home.features.noTimeLimit.title"),
            description: t("home.features.noTimeLimit.description"),
            highlights: t("home.features.noTimeLimit.highlights", { returnObjects: true }) as string[],
        },
        {
            icon: <TbLockQuestion size={28} />,
            title: t("home.features.hintsIfNeeded.title"),
            description: t("home.features.hintsIfNeeded.description"),
            highlights: t("home.features.hintsIfNeeded.highlights", { returnObjects: true }) as string[],
        },
        {
            icon: <FaUsers size={28} />,
            title: t("home.features.multiplayer.title"),
            description: t("home.features.multiplayer.description"),
            highlights: t("home.features.multiplayer.highlights", { returnObjects: true }) as string[],
        },
    ];
    return (
        <Section variant="purple-cyan">
            <div className={styles.container}>
                <Stack gap="xl" align="center">
                    {/* Section Header */}
                    <SectionTitle title={t("home.features.title")} subTitle={t("home.features.subtitle")} />
                    {/* Feature Cards */}
                    <SimpleGrid cols={{ xs: 1, md: 2, lg: 4 }} spacing="xl" className={styles.grid}>
                        {features.map((feature) => (
                            <Card key={feature.title} {...feature} />
                        ))}
                    </SimpleGrid>
                </Stack>
            </div>
        </Section>
    );
};
